const PublicI18n = {
    zh:{
        meatTitle:'收益宝产品说明',
        tabTitle1:'简介',
        tabTitle2:'认购流程',
    },
    en:{
        meatTitle:'CryptoGain Product Description',
        tabTitle1:'Profile',
        tabTitle2:'Purchase Process',
    }
}
export default PublicI18n